let forms = require( './forms' ),
	modals = require( './modals' );

let pre_booking_confirmations = ( function ( $ ) {

	let $form;

	let _init = function() {
		$form = $( '#pre_booking_confirmation_form' );

		if ( $form.length > 0 ) {
			$form.on( 'submit_success', _confirmations_completed );
		}
	};

	let _confirmations_completed = function() {
		modals.close_modal( $( '#pre_booking_modal' ) );
		forms.save_external( $( '.crate-form.add-to-cart-form' ).attr( 'id' ), false );
	};

	$( document ).ready( _init );

} )( jQuery );